import Page from '../components/Page';
import { Grid, Container, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Device } from '../@types/model/device';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Icon } from '@iconify/react';
import Services from './workspaces/repsol/Services';
import Benefits from './workspaces/repsol/Benefits';
import { useSelector, RootState } from '../redux/store';
import { useTheme, styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { generatePath, NavLink } from 'react-router-dom';
import { PATH_DASHBOARD } from './../routes/paths';
import axios from './../utils/axios';
import { checkWorkspace, WORKSPACES_REPSOL } from 'guards/CheckRoles';

const HeaderClientUser = styled('div')(({ theme }) => ({
  backgroundImage: 'url(/static/background/backgroundblue.webp)',
  color: '#f0f0f0',
  backgroundSize: 'cover',
  height: '700px',
  [theme.breakpoints.up('sm')]: {
    height: '660px'
  },
  [theme.breakpoints.up('md')]: {
    height: '400px'
  },
  paddingBottom: 40,
  paddingTop: 40,
  paddingLeft: 20,
  paddingRight: 20
}));

const IconAgrupation = styled('div')(({ theme }) => ({
  display: 'inline-block',
  paddingRight: 15,
  paddingTop: 2,
  [theme.breakpoints.up('sm')]: {
    paddingTop: 15
  }
}));

export const getDevices = async (
  page: number,
  size: number,
  okCallback: (deviceGroups: Device[], totalCount: number) => void
): Promise<void> => {
  const queryParams: any = {
    offset: page * size,
    size
  };

  axios
    .get('/api/v2/device', {
      params: queryParams
    })
    .then(({ data }: any) => {
      okCallback(
        data.data.map((item: any) => {
          return item as Device;
        }),
        data.meta.total_count
      );
    });
};

const DashboardHomeEndClient = () => {
  const theme = useTheme();
  const [device, setDevice] = useState<Device | null>(null);
  const { user } = useSelector((state: RootState) => state.user);
  const { workspace } = useSelector((state: RootState) => state.workspace);

  useEffect(() => {}, [user, workspace]);

  useEffect(() => {
    const fetchData = async () => {
      await getDevices(0, 1, (data: Device[], count: number) => {
        setDevice(data[0]);
      });
    };
    fetchData().catch(console.error);
  }, []);

  return (
    <Page title={'Giraf'}>
      <HeaderClientUser>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography style={styles.headerName}>Hola, {user?.attributes?.name}</Typography>
              <Typography>Esto es todo lo que has conseguido:</Typography>
              <Typography style={styles.headerAmount}>107,60€</Typography>
              <Typography>Has ahorrado con Repsol en los últimos 12 meses</Typography>
              <NavLink
                to={generatePath(PATH_DASHBOARD.end_client.devices.details, {
                  guid: device?.guid ?? ''
                })}
                style={styles.link}
              >
                Ver detalle
                <Icon icon="fa:angle-right" style={styles.iconArrow} />
              </NavLink>
            </Grid>
            <Grid item xs={12} md={6} style={{ paddingTop: 40 }}>
              <Grid container spacing={1}>
                <Grid item xs={4} sm={3}>
                  <Card
                    style={{
                      ...styles.card,
                      height: 100
                    }}
                  >
                    <CardContent style={styles.cardContentAlignVertical}>
                      <Typography style={styles.numbers}>12,33€</Typography>
                      <Typography style={styles.texto}>Saldo en Waylet</Typography>
                    </CardContent>
                  </Card>
                  <Card
                    style={{
                      ...styles.card,
                      height: 100
                    }}
                  >
                    <CardContent style={styles.cardContentAlignVertical}>
                      <Typography style={styles.numbers}>212.300</Typography>
                      <Typography style={styles.texto}>Puntos Travel Club</Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={8} sm={9}>
                  <Card
                    style={{
                      ...styles.card,
                      height: 210
                    }}
                  >
                    <CardContent style={styles.cardContent}>
                      <Typography style={styles.numbers}>12</Typography>
                      <Typography style={styles.texto}>Cupones</Typography>
                      <div>
                        <IconAgrupation>
                          <Icon icon="bi:bag-fill" style={styles.iconIcon} />
                          <Typography style={styles.texto}>2 Compras</Typography>
                        </IconAgrupation>
                        <IconAgrupation>
                          <Icon icon="bi:fire" style={styles.iconIcon} />
                          <Typography style={styles.texto}>0 Bombona</Typography>
                        </IconAgrupation>
                        <IconAgrupation>
                          <Icon icon="fa6-solid:truck-droplet" style={styles.iconIcon} />
                          <Typography style={styles.texto}>1 Gasóleo</Typography>
                        </IconAgrupation>
                        <IconAgrupation>
                          <Icon icon="bx:gas-pump" style={styles.iconIcon} />
                          <Typography style={styles.texto}>1 Carburante</Typography>
                        </IconAgrupation>
                        <IconAgrupation>
                          <Icon icon="ci:bulb" style={styles.iconIcon} />
                          <Typography style={styles.texto}>4 Luz y gas</Typography>
                        </IconAgrupation>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <NavLink
                    to={generatePath(PATH_DASHBOARD.end_client.devices.details, {
                      guid: device?.guid ?? ''
                    })}
                    style={styles.cardDetail}
                  >
                    Ver todo en detalle
                  </NavLink>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </HeaderClientUser>
      {checkWorkspace(workspace, WORKSPACES_REPSOL) && (
        <div style={styles.backgroundGray}>
          <Services />
          <Benefits />
        </div>
      )}
    </Page>
  );
};

export default DashboardHomeEndClient;

const styles = {
  iconArrow: { verticalAlign: 'sub', marginLeft: 10, fontSize: 20 },
  titleSection: {
    color: '#ff6000',
    fontSize: 30,
    marginTop: 40,
    marginBottom: 30,
    fontFamily: "'Exo 2', sans-serif"
  },
  backgroundGray: {
    background: '#f7f7f7'
  },
  headerName: {
    fontSize: 40,
    fontFamily: "'Exo 2', sans-serif"
  },
  headerAmount: {
    fontSize: 36,
    paddingTop: 40,
    headerBottom: 10,
    fontFamily: "'Exo 2', sans-serif"
  },
  link: {
    textDecoration: 'none',
    color: 'white',
    marginTop: 10,
    display: 'inline-block'
  },
  numbers: {
    color: 'orange',
    fontSize: 20,
    fontFamily: "'Exo 2', sans-serif"
  },
  texto: {
    fontSize: 13
  },
  icons: {},
  iconIcon: {
    marginBottom: -5
  },
  card: {
    borderRadius: 5,
    marginBottom: 10,
    width: '100%',
    display: 'flex' as 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center' as 'center'
  },
  cardContent: {
    padding: '10px 15px'
  },
  cardContentAlignVertical: {
    padding: '0px 15px',
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    height: 100
  },
  cardDetail: {
    borderRadius: 5,
    marginBottom: 10,
    width: '100%',
    background: '#b3edf4',
    display: 'block',
    padding: '10px 20px',
    color: '#006f78',
    textAlign: 'center' as 'center',
    textDecoration: 'none',
    marginTop: -10
  },
  cardContentDetail: {
    padding: '10px 15px'
  },
  root: {
    backgroundColor: 'blue'
  }
};
